const validate = values => {
  const errors = {}

  if (!values.event_info_form?.name) {
    errors.event_info_form = {
      ...errors.event_info_form,
      name: "The event name is required!",
    }
  }

  if (values.event_info_form?.startHour && !values.event_info_form?.startDate) {
    errors.event_info_form = {
      ...errors.event_info_form,
      startDate: "You can't set the Start Time without the Start Date!",
    }
  }

  if (values.event_info_form?.endHour && !values.event_info_form?.endDate) {
    errors.event_info_form = {
      ...errors.event_info_form,
      endDate: "You can't set the End Time without the End Date!",
    }
  }

  if (values.event_info_form?.startDate && values.event_info_form?.endDate) {
    const startDate = new Date(`${values.event_info_form?.startDate} `)
    const endDate = new Date(`${values.event_info_form?.endDate}`)
    if (startDate > endDate) {
      errors.event_info_form = {
        ...errors.event_info_form,
        endDate: "The Start Time cannot be after the End Time!",
      }
    }
  }

  if (
    values.event_info_form?.meetingLink &&
    !/(http(s)?:\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i.test(
      values.event_info_form?.meetingLink
    )
  ) {
    errors.event_info_form = {
      ...errors.event_info_form,
      meetingLink:
        "The link is invalid! It must include both http:// or https:// and a suffix like .com",
    }
  }

  return errors
}

export default validate
